import * as React from "react";
import { cn } from "@/utils/utils";

export interface TInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    error?: boolean;
}

/**
 * PRODA Input Component
 *
 * Clean input field with PRODA brand styling
 */
const Input = React.forwardRef<HTMLInputElement, TInputProps>(
    ({ className, type, error, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    "flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-sm transition-colors duration-200",
                    "ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium",
                    "placeholder:text-muted-foreground",
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:border-primary",
                    "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted",
                    error && "border-destructive focus-visible:ring-destructive",
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Input.displayName = "Input";

export { Input };
